import { Spinner } from '@talentmesh/ui/components/spinner';

const AtsDialogLoading = () => (
    <div className="flex items-center justify-center gap-2 py-10" data-cy="AtsImportDialogLoading">
        <Spinner className="text-primary size-6" />
    </div>
);

export default AtsDialogLoading;
